var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2813_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.45 16H14.54L9.42999 3H7.56999L2.45999 16H4.54999L5.66999 13H11.31L12.45 16ZM6.42999 11L8.49999 5.48L10.57 11H6.42999Z",
    fill: "#6743D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.59 11.5901L13.5 19.6801L9.82995 16.0001L8.41995 17.4101L13.51 22.5001L23 13.0001L21.59 11.5901Z",
    fill: "#63F51F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3H18V14.5L16.5 16H16V3Z",
    fill: "#6743D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2813_760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChecked);
export default __webpack_public_path__ + "static/media/AI Checked.9f80b9384e8136153eabe2b0252421b8.svg";
export { ForwardRef as ReactComponent };